import {Component, OnInit} from '@angular/core';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {WebhookLogModel} from '../../data/model/WebhookLogModel/webhook_log.model';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {GetWebhookLogsListAction} from './get-webhook-logs-list.action';
import {Subject} from 'rxjs';
import {AppConstants} from '../../shared/constants/app-constants';
import {debounceTime} from 'rxjs/operators';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {ExportModel} from '../../data/model/ExportModel/export-model';
import {ExportConstants} from '../../shared/constants/export-constants';
import { ariaSort, SortDirection } from '../../ui/table/payarc-sort-icon.component';
import { PagerPage } from '../../ui/pager/payarc-pager.component';

@Component({
    selector: 'app-webhook-logs-list',
    templateUrl: './webhook-logs-list.component.html',
    styleUrls: ['./webhook-logs-list.component.css'],
    standalone: false
})
export class WebhookLogsListComponent extends GetWebhookLogsListAction implements OnInit {
  exportExcel : ExportModel[] = ExportConstants.webhookLogListExport;
  showExport = false;
  exportData = {exportServiceName: AppConstants.SERVICE_NAME_EXPORT_DASHBOARD + '/web-hook-log', redirectUrl : '/events-and-logs/webhooks', fileName: 'Payarc_WebhookLogs_Report', heading : 'Webhook Logs '};
  dataManager: DataManagerService;
  webhookList: ApiResponseModel<WebhookLogModel>;
  perPage = 20;
  route: ActivatedRoute;
  excel = 1;
  blob: any;
  constructor(dataManager: DataManagerService, router: Router, route: ActivatedRoute, snackBar: MatSnackBar) {

    super();
    this.snackBar = snackBar;
    this.loadFlag = true;
    this.router = router;
    this.errorMsg = null;
    this.route = route;
    this.redirect_link = '/webhook-log-details';
    this.searchHits = new Subject<void>();

    if (this.fetchIdAndKeyFromRouteQueryParams()) {
      this.getListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_WEBHOOK_LOG;
      this.includes = '?' + this.key + '=' + this.id;
      } else {
       this.getListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_WEBHOOK_LOG;
    }
    this.dataManager = dataManager;
    this.webhookList = new ApiResponseModel();
    this.setUrl();
  }

  ngOnInit(): void {
    this.searchHits.pipe(debounceTime(600), ).subscribe((res) => {
      if (!this.isNullOrUndefined(this.searchText)) {
        this.setUrl();
      }
    });
  }
  exportexcel() {
    this.showExport = true;
    this.exportData['include'] = '&full_path=App\\Containers\\AppSection\\WebHook\\Data\\Repositories\\&is_full_path=1';
  }

  protected getListErr(err) {
    this.errorMsg = this.networkErrorHandler(err.error, ErrorConstants.webhookLogDetailErrorMsg);
  }

  protected getListRes(webhookResponse: ApiResponseModel<WebhookLogModel>) {
    this.loadFlag = false;
    this.webhookList = webhookResponse;
    this.metadata = webhookResponse.meta.pagination;
    if (this.webhookList.data.length === 0) {
      this.errorMsg = ErrorConstants.webhookLogDetailErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }
  paginate(paginateExtension) {
    this.loadFlag = true;
    this.getList(paginateExtension);
  }

  openWebhookLog($event, webhook) {
    this.router.navigateByUrl(this.redirect_link + '?id=' + webhook.id);
  }

  onSearch(value: string) {
    this.searchText = value;
    this.searchHits.next();
  }

  sortDirection(key: string): SortDirection {
    if (this.orderBy !== key) { return null; }
    return this.sortBy === 'asc' ? 'asc' : 'desc';
  }

  ariaSort = ariaSort;

  get pagerRangeLabel(): string {
    const pagination: any = this.metadata;
    if (!pagination?.total) { return ''; }
    const start = 1 + (pagination.current_page - 1) * this.limit;
    const end = pagination.current_page === 1 ? pagination.count : pagination.count + (pagination.current_page - 1) * this.limit;
    return `Showing ${start}–${end} of ${pagination.total}`;
  }

  pagerPrev() {
    this.paginate((this.metadata as any)?.links?.previous);
  }

  pagerNext() {
    this.paginate((this.metadata as any)?.links?.next);
  }

  pagerSelect(page: PagerPage) {
    const links = (this.metadata as any)?.links;
    const url = links?.next || links?.previous;
    if (url) { this.nextpage(page as number, url); }
  }

  protected passwebhookExcelError(err) {
    console.log(err);
  }

  protected passwebhookExcelResponse(res) {
    this.blob = new Blob([res], { type: 'application/vnd.ms-excel' });
    const downloadURL = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = 'Payarc_WebhookLog_Report.xls';
    link.click();
  }
}
